/**
 * the base manifest holds the core functionality, namely its action creator
 * for starting a ufp application
 */
import UfpCoreActionCreators from './UfpCoreActionCreators'

const Runfest = {
    name: 'Ufp Base',
    description: 'Ufp Base',
    actionCreators: UfpCoreActionCreators

}

export default Runfest
